import { TypographyOptions } from '@mui/material/styles/createTypography';

import { baseTheme } from './base';

const primaryFontFamily = "'Roobert', sans-serif";
const primaryFontLineHeight = 1.2;

enum FontWeight {
  light = 300,
  regular = 400,
  medium = 500,
  semibold = 600,
  bold = 700,
}

export const typography: TypographyOptions = {
  fontFamily: primaryFontFamily,
  htmlFontSize: 16,
  h1: {
    fontFamily: primaryFontFamily,
    fontSize: '4.5rem',
    fontWeight: FontWeight.semibold,
    lineHeight: primaryFontLineHeight,
  },
  h2: {
    fontFamily: primaryFontFamily,
    fontSize: '2.286rem',
    fontWeight: FontWeight.semibold,
    lineHeight: primaryFontLineHeight,
  },
  h3: {
    fontFamily: primaryFontFamily,
    fontSize: '1.5rem',
    fontWeight: FontWeight.regular,
    lineHeight: primaryFontLineHeight,
  },
  h4: {
    fontFamily: primaryFontFamily,
    fontSize: '1.5rem',
    fontWeight: FontWeight.semibold,
    lineHeight: primaryFontLineHeight,
  },
  h5: {
    fontFamily: primaryFontFamily,
    fontSize: '1rem',
    fontWeight: FontWeight.regular,
    lineHeight: primaryFontLineHeight,
  },
  h6: {
    fontFamily: primaryFontFamily,
    fontSize: '0.875rem',
    fontWeight: FontWeight.bold,
    lineHeight: primaryFontLineHeight,
    textTransform: 'none',
  },
  subtitle1: {
    fontFamily: primaryFontFamily,
    fontSize: '1.125rem',
    fontWeight: FontWeight.semibold,
    lineHeight: primaryFontLineHeight,
  },
  subtitle2: {
    fontFamily: primaryFontFamily,
    fontSize: '1.125rem',
    fontWeight: FontWeight.regular,
    lineHeight: primaryFontLineHeight,
  },
  body1: {
    color: baseTheme.palette.grey[100],
    fontFamily: primaryFontFamily,
    fontSize: '1rem',
    fontWeight: FontWeight.medium,
    lineHeight: primaryFontLineHeight,
  },
  body2: {
    fontFamily: primaryFontFamily,
    fontSize: '0.875rem',
    fontWeight: FontWeight.medium,
    lineHeight: primaryFontLineHeight,
  },
  button: {
    fontFamily: primaryFontFamily,
    fontSize: '1rem',
    fontWeight: FontWeight.medium,
    lineHeight: 1.714,
    textTransform: 'none',
  },
  caption: {
    fontFamily: primaryFontFamily,
    fontSize: '0.75rem',
    fontWeight: FontWeight.regular,
    lineHeight: primaryFontLineHeight,
  },
  overline: {
    fontFamily: primaryFontFamily,
    fontSize: '0.875rem',
    fontWeight: FontWeight.regular,
    lineHeight: primaryFontLineHeight,
    textTransform: 'none',
  },
};
